import React from 'react';
import PropTypes from 'prop-types';
import LineItem from './LineItem';

const LineItems = ({ lineItems, className }) => lineItems.length < 1 ? null : (
  <ul className={className}>
    {lineItems.map(lineItem => (
        <LineItem
          key={lineItem.serviceId}
          lineItem={lineItem}
        />
    ))
    }
  </ul>
);

LineItems.PropTypes = {
  lineItems:PropTypes.array.isRequired,
  className:PropTypes.string.isRequired,
};

export default LineItems;
